    <!-- Header -->
    <app-title title="Organization List"></app-title>      
        <div class="card my-10">
            <p-table
              [value]="orgList"
              [paginator]="true"
              [rows]="perPage"
              [totalRecords]="totalRecords"
              [tableStyle]="{ 'min-width': '50rem' }"
              [rowsPerPageOptions]="[10,20,50]"
              (onLazyLoad)="onPageChange($event)"
              [lazy]="true"
              [resizableColumns]="true"
              [reorderableColumns]="true"
              >
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="sno">S.No</th>
                  <th pSortableColumn="orgName">Name</th>
                  <th pSortableColumn="orgCode">Code
                </th>
                  <th>Action</th>
                </tr>
              </ng-template>
          
              <!-- Body Template -->
              <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                <tr>
                  <td>{{ rowIndex + 1 }}</td>
                  <td>{{ rowData.name.replaceAll('_', ' ') | titlecase }}</td>
                  <td>{{ rowData.code.replaceAll('_', ' ') }}</td>
                  <td>
                    <!-- Add actions here -->
                    <button pButton type="button" icon="pi pi-eye" class="p-button-text" title="View"  [routerLink]="'/settings/org/view/'+ rowData.id" severity="secondary"></button>
                    <button pButton type="button" icon="pi pi-pen-to-square" class="p-button-text" title="Edit" [routerLink]="'/settings/org/update/'+ rowData.id" severity="secondary"></button>
                    <button pButton type="button" icon="pi pi-trash" class="p-button-text" title="Delete" severity="secondary" (click)="confirmDelete(rowData.id, $event)" ></button>
                  </td>
                </tr>
              </ng-template>
          
              <!-- Empty Data Template -->
              <ng-template pTemplate="empty">
                <tr>
                  <td colspan="7" class="text-center">No Organizations Found</td>
                </tr>
              </ng-template>
            </p-table>
            <p-confirmDialog header="Delete Confirmation" icon="pi pi-exclamation-triangle" [acceptLabel]="'Delete'" [rejectLabel]="'Cancel'"
  (onAccept)="deleteOrg()">
</p-confirmDialog>
          </div>